import React from "react";
import {IconSource} from "../../../shared/enums/iconSource";
import {ImageObservable} from "../../../stores/observables/imageObservable";
import ButtonIcon from "../../atoms/button/buttonIcon";
import FadeContent from "../../molecules/fadeContent/fadeContent";
import "./imagePreview.sass";
import {ImageEditorObservable} from "../../../stores/observables/imageEditorObservable";

export interface IImagePreviewProps {
  value: ImageObservable | ImageEditorObservable;
  disabled?: boolean;
}

const ImagePreview: React.FC<IImagePreviewProps> = ({
  value,
  disabled = false
}) => {
  const isSrcEmpty = value.file === null;
  return (
    <FadeContent fadeContent={isSrcEmpty}>
      <div className="image-preview">
        <div>
          <img
            alt={value.fileName ?? value.fileId}
            src={isSrcEmpty ? "" : window.URL.createObjectURL(value.file!)}
          />
        </div>
        {!disabled && (
          <ButtonIcon
            icon={IconSource.delete}
            type="accessory"
            onClick={() => {
              value.resetFile();
            }}
          />
        )}
      </div>
    </FadeContent>
  );
};

export default ImagePreview;
